<template>
      <v-list dense  class=" ml-6 fix-side-menu" >
        <span :key="`mnu-`+i" v-for="(itm, i) in sideMenu">
                <v-list-item link  @click='goToPage(itm)'>


                  <v-list-item-content :class="{ active: currItemMenu === itm.url.toString() }">

                    <span class="text-left title " > {{itm.title}}</span>
                  </v-list-item-content>
                </v-list-item>

        </span>
      </v-list>


</template>
<script>
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default {
  name: 'SideMenu',
  data () {
    return {
    //  currItemMenu: null,
      
    }
  },
     computed:{
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },       
        pages: {
          get () {
            let vApp = this;
            return vApp.$store.state.pages.allPages;
          },

        },       
        sideMenu: {
          get () {
            return this.$store.state.menu.menu
          },
          set (val) {
            let vApp = this
            vApp.$store.dispatch('updateMenu', val)
          }
        },
        currItemMenu: {
          get () {
            return this.$store.state.menu.currItemMenu
          },
          set (val) {
            let vApp = this
            vApp.$store.dispatch('setCurrentMenu', val)
          }
        },
     },
    methods: {

      goToPage (itemMnu) {
        let vApp = this
        vApp.drawer = false
         console.log(' gotoPAGE url :>> ', itemMnu.url)
         
         
        setTimeout(function() {
            if(itemMnu.url == '/'){
              vApp.$router.push('/')
            }
            else{          
          if (vApp.$route.path !== itemMnu.url){
           
            console.log(' gotoPAGE ID :>> ', itemMnu.id)
            if(itemMnu.id < 12) {
            vApp.currItemMenu = itemMnu.url
             vApp.$router.push('/'+itemMnu.url).catch(error => {
                if (error.name !== 'NavigationDuplicated') {
                  throw error
                }
              })
             
             }
             else{
               console.log('vApp.pages :>> ',vApp.pages)
               console.log(' currItemMenu :>> ', itemMnu.url.split('/'))
              const getPageInfo = vApp.pages.find(fpi=>fpi.slug === itemMnu.url)
               vApp.currItemMenu = itemMnu.url
               //vApp.currItemMenu = itemMnu.url.split('/')[1]
               console.log('GoTo Single Page :>> ',getPageInfo)
               console.log('GoTo Single Page :>> /page/',itemMnu.url)
                vApp.$router.push('/page/'+itemMnu.url).catch(error => {
                if (error.name !== 'NavigationDuplicated') {
                //  console.log('GoTo Single Page ERROR :>> ',error)
                  throw error
                }
                
              })
               vApp.$router.go()
             }
             }
             }

        }, 500);


      },


    },
  mounted () {    
    console.log('mounted Side Menu ')
    let vApp = this
    this.$nextTick(function () {
        console.log('vApp.$route NAME :', vApp.$route.path);
        vApp.currItemMenu = vApp.$route.path.split('/')[1];
    })

  },
}
</script>
<style  scoped>

.active{
  text-decoration: underline;
}
.fix-side-menu{
  position: fixed;
  left: 0;
}
</style>